import { format } from "date-fns";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hook.ts";
import { AppointmentsDTO } from "./dto.ts";
import { findByIdAppointment, setModalAppointmentType, setNewAppointmentModal } from "./slice.ts";
import { AppointmentTooltip } from "./tooltip.tsx";

interface Props {
    appointment: AppointmentsDTO;
    setAppointment: (appointment: AppointmentsDTO) => void;
}
export function MonthAppointment(props: Props) {
    const { appointment } = props;
    const [visible, setVisible] = useState(false);
    const [mouseY, setMouseY] = useState(0);
    const [mouseX, setMouseX] = useState(0);
    const isLastColumn = new Date(appointment.startDate).getDay() === 0;
    const dispatch = useAppDispatch()
    const layoutState = useAppSelector(state => state.layout);

    return (
        <div
            onClick={() => {
                dispatch(setModalAppointmentType("edit"));
                dispatch(findByIdAppointment(appointment.id));
                dispatch(setNewAppointmentModal(true));
                props.setAppointment(appointment)
            }}
            onMouseEnter={() => setVisible(true)}
            onMouseMove={(e) => { !visible && setMouseY(e.clientY); !visible && setMouseX(e.clientX) }}
            onMouseLeave={() => setVisible(false)}
            style={{
                backgroundColor: layoutState.theme[100],
                color: layoutState.theme[800],
                borderColor: layoutState.theme[300],
            }}
            key={appointment.id}
            className="h-7 cursor-pointer relative items-center text-text-xs font-bold w-full border rounded-lg p-2 flex justify-between">
            <AppointmentTooltip visible={visible} appointment={appointment} isLastColumn={isLastColumn} mouseY={mouseY} mouseX={mouseX} />
            <span className="crop-text">{appointment.title}</span>
            <span className="text-nowrap">{format(appointment.startDate!, "HH:mm")}</span>
        </div>
    )
}